import { Component, ElementRef, viewChild } from '@angular/core';

@Component({
  selector: 'lepi-modal-container',
  template: `
    <section
      #modal
      class="w-screen h-[100dvh] md:rounded-2xl md:w-auto md:h-auto bg-base-100 shadow-2xl border border-base-200 overflow-hidden">
      <section>
        <ng-content select="[header]" />
      </section>
      <section
        class="h-full md:min-w-120 md:max-h-240 md:h-auto overflow-y-auto">
        <ng-content />
      </section>
      <section class="md:static fixed bottom-0 w-full bg-base-100">
        <ng-content select="[footer]" />
      </section>
    </section>
  `,
  imports: [],
})
export class ModalContainer {
  modalRef = viewChild<ElementRef<HTMLElement>>('modal');

  ngAfterViewInit() {
    this.modalRef()?.nativeElement.animate(
      [
        { opacity: 0, transform: 'translateY(10px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ],
      {
        duration: 200,
        easing: 'ease-in-out',
      }
    );
  }
}
